import { useTranslation } from 'react-i18next';

const reviews = [
  {
    title: 'Miglior strumento di ricerca',
    body: 'Itaobuy Spreadsheet mi ha aiutato a trovare prodotti di qualità che non avrei mai scoperto da solo. I dati sono sempre aggiornati e ben organizzati.',
    author: 'Marco R.',
    role: 'Acquirente Verificato',
  },
  {
    title: 'Risparmio tempo e denaro',
    body: 'Prima passavo ore a cercare prodotti su diversi siti. Con Itaobuy Sheet trovo tutto in un unico posto, confronto i prezzi e scelgo il migliore.',
    author: 'Elena B.',
    role: 'Shopping Enthusiast',
  },
  {
    title: 'Database completo e affidabile',
    body: 'Le informazioni sono dettagliate e precise. Ho trovato sneakers limited edition che cercavo da mesi grazie al database aggiornato.',
    author: 'Luca M.',
    role: 'Sneaker Collector',
  },
  {
    title: 'Guida indispensabile',
    body: 'Come acquirente italiano, apprezzo molto le guide in italiano. Spiegano tutto in modo chiaro e mi aiutano a fare scelte migliori.',
    author: 'Sofia D.',
    role: 'Fashion Blogger',
  },
  {
    title: 'Qualità garantita',
    body: 'Il sistema di controllo qualità integrato nel foglio di calcolo è incredibilmente utile. Mi sento più sicuro nei miei acquisti.',
    author: 'Andrea P.',
    role: 'Cliente Fedele',
  },
  {
    title: 'Perfetto per lo streetwear',
    body: 'La sezione streetwear è fantastica. Trovo sempre le ultime uscite e posso confrontare i prezzi tra diversi venditori in tempo reale.',
    author: 'Giulia T.',
    role: 'Streetwear Lover',
  },
];

export default function ReviewSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-accent-50/40 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-foreground-800"></span>
            <span className="text-xs font-medium text-foreground-600 tracking-wide uppercase">
              {t('reviews.badge')}
            </span>
          </div>
          <h2 className="text-foreground-950 font-heading text-3xl md:text-4xl font-bold leading-tight">
            {t('reviews.title1')}
            <br />
            {t('reviews.title2')}
          </h2>
          <p className="text-foreground-500 text-sm mt-4 max-w-md mx-auto">
            {t('reviews.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <h4 className="text-foreground-950 font-semibold text-base mb-2">{review.title}</h4>
                <p className="text-foreground-500 text-sm leading-relaxed">{review.body}</p>
              </div>
              <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/50">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-accent-700 font-semibold text-sm">
                    {review.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-foreground-900 text-sm font-semibold">{review.author}</p>
                  <p className="text-foreground-400 text-xs">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}